// ARQUIVO 100% COMPLETO E CORRIGIDO
import React, { useMemo, useState } from 'react';
import useData from '../../hooks/useData';
import DropdownMenu from '../ui/DropdownMenu';
import { ChevronDownIcon } from '../ui/Icons';
import DrillDownModal from '../modals/DrillDownModal';

const MetricBox = ({ label, value, onClick, unit = '' }) => (
    <button 
        onClick={onClick} 
        disabled={!onClick}
        className="bg-black/20 p-3 rounded-lg text-center w-full h-full flex flex-col items-center justify-center transition-colors hover:bg-black/40 disabled:hover:bg-black/20 overflow-hidden"
    >
        <p className="text-2xl sm:text-4xl font-bold text-white leading-tight truncate">{value}</p>
        <div className="text-[10px] sm:text-xs text-gray-400 uppercase tracking-wider leading-tight text-center">
            <span>{label}</span>
            <span className="truncate"> {unit}</span>
        </div>
    </button>
);

// --- INÍCIO DA ALTERAÇÃO: Adicionando a prop `onTaskClick` ---
const MetricsWidget = ({ onTaskClick }) => {
// --- FIM DA ALTERAÇÃO ---
    const { tasks } = useData();
    const [timeframe, setTimeframe] = useState('7days');
    const [drillDownData, setDrillDownData] = useState(null);

    const timeframes = {
        '7days': { label: 'Últimos 7 dias' },
        'thisMonth': { label: 'Este Mês' },
        '30days': { label: 'Últimos 30 dias' },
    };

    const performanceData = useMemo(() => {
        const now = new Date();
        let startDate = new Date();
        const endDate = new Date(now);

        now.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        switch (timeframe) {
            case 'thisMonth':
                startDate = new Date(now.getFullYear(), now.getMonth(), 1);
                break;
            case '30days':
                startDate.setDate(now.getDate() - 30);
                break;
            case '7days':
            default:
                startDate.setDate(now.getDate() - 7);
                break;
        }
        startDate.setHours(0, 0, 0, 0);

        const completedTasks = tasks.filter(task => {
            if (task.status !== 'Concluído' || !task.deadline) return false;
            const deadlineDate = new Date(task.deadline + 'T00:00:00');
            return deadlineDate >= startDate && deadlineDate <= endDate;
        });

        const numDays = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);

        const dailyCounts = {};
        completedTasks.forEach(task => {
            const dateKey = task.deadline;
            dailyCounts[dateKey] = (dailyCounts[dateKey] || 0) + 1;
        });
        
        const busiestDay = Object.entries(dailyCounts).sort((a, b) => b[1] - a[1])[0];

        return {
            totalCompleted: completedTasks.length,
            dailyAverage: (completedTasks.length / (numDays > 0 ? numDays : 1)).toFixed(1),
            busiestDay: busiestDay ? { date: busiestDay[0], count: busiestDay[1] } : null,
            completedTasks,
        };
    }, [tasks, timeframe]);
    
    const handleDrillDown = (title, tasks) => {
        setDrillDownData({ title, tasks });
    };

    return (
        <>
            <div className="p-4 h-full flex flex-col animate-fade-in" style={{ animationDelay: '100ms' }}>
                <div className="flex justify-between items-center mb-4 flex-shrink-0">
                    <h3 className="text-lg font-bold text-white">Performance</h3>
                    <DropdownMenu trigger={
                        <button className="flex items-center gap-2 bg-black/20 text-white text-xs font-semibold rounded-full py-1.5 px-3 hover:bg-black/40 transition-colors">
                            <span>{timeframes[timeframe].label}</span>
                            <ChevronDownIcon size={16} className="text-gray-400" />
                        </button>
                    }>
                        <div className="w-40">
                            {Object.entries(timeframes).map(([key, { label }]) => (
                                <button key={key} onClick={() => setTimeframe(key)} className="w-full text-left px-3 py-2 text-sm text-gray-200 hover:bg-indigo-600">
                                    {label}
                                </button>
                            ))}
                        </div>
                    </DropdownMenu>
                </div>
                
                <div className="grid grid-cols-3 gap-4 flex-grow">
                    <MetricBox 
                        label="Concluídas" 
                        value={performanceData.totalCompleted}
                        onClick={() => handleDrillDown(`Tarefas Concluídas (${timeframes[timeframe].label})`, performanceData.completedTasks)}
                    />
                    <MetricBox label="Média Diária" value={performanceData.dailyAverage} />
                    <MetricBox 
                        label="Dia Mais Produtivo" 
                        value={performanceData.busiestDay?.count || 0}
                        unit={performanceData.busiestDay ? `(${new Date(performanceData.busiestDay.date + 'T00:00:00').toLocaleDateString('pt-BR', {day:'2-digit', month:'2-digit'})})` : ''}
                    />
                </div>
            </div>
            
            {/* --- INÍCIO DA ALTERAÇÃO: Passando `onTaskClick` para o modal --- */}
            <DrillDownModal 
                data={drillDownData} 
                onClose={() => setDrillDownData(null)}
                onTaskClick={onTaskClick}
            />
            {/* --- FIM DA ALTERAÇÃO --- */}
        </>
    );
};

export default MetricsWidget;